import { ViewModel } from "../mvvm/ViewModel.js";
import { ApiError } from "@lumora/bridge";
const SUBSCRIBE_UNCONFIGURED_ERROR = "Platform Stripe billing is not configured on this server (set LUMORA_STRIPE_SECRET_KEY and LUMORA_STRIPE_PRICE_*).";
function formatSubscribeError(err) {
    if (err instanceof ApiError && err.code === "billing_disabled") {
        return SUBSCRIBE_UNCONFIGURED_ERROR;
    }
    if (err instanceof Error && err.message.trim().toLowerCase() === "billing is not configured") {
        return SUBSCRIBE_UNCONFIGURED_ERROR;
    }
    return undefined;
}
/**
 * SubscribeViewModel selects a plan and initiates a subscription via the
 * bridge. The returned clientSecret is consumed by a Stripe Payment Element
 * view when present; an empty secret with subscriptionId means the plan is
 * already active (e.g. payg $0).
 */
export class SubscribeViewModel extends ViewModel {
    client;
    constructor(client) {
        super({
            planKey: null,
            loading: false,
            error: null,
            clientSecret: null,
            subscriptionId: null,
        });
        this.client = client;
    }
    selectPlan(key) {
        this.setState({ planKey: key, subscriptionId: null, clientSecret: null, error: null });
    }
    /** True when subscribe finished without needing a Payment Element (#451). */
    get isActiveWithoutPayment() {
        return this.state.subscriptionId != null && !this.state.clientSecret;
    }
    async start() {
        if (!this.state.planKey) {
            throw new Error("No plan selected");
        }
        this.setState({ clientSecret: null, subscriptionId: null });
        await this.run(async () => {
            const result = await this.client.subscribe({
                plan: this.state.planKey,
            });
            const secret = result.clientSecret?.trim() ? result.clientSecret : null;
            this.setState({
                clientSecret: secret,
                subscriptionId: result.subscriptionId || null,
            });
        }, "Failed to start subscription.", {
            onError: (err) => {
                const override = formatSubscribeError(err);
                return override
                    ? { clientSecret: null, subscriptionId: null, error: override }
                    : { clientSecret: null, subscriptionId: null };
            },
        });
    }
}
//# sourceMappingURL=SubscribeViewModel.js.map